module.exports = __webpack_public_path__ + "static/media/Alert.be5a4d7f.svg";